import { createAction } from '@reduxjs/toolkit';

export interface PlanCallPayload {
    url: string;
    sessionId: string;
    isBroadcast?: boolean;
}

export interface PlanCallErrorPayload {
    isBroadcast?: boolean;
}

export const onSuccessPlanning = createAction<PlanCallPayload>('@CALL/SUCCESS_PLANNING');
export const onErrorPlanning = createAction<PlanCallErrorPayload>('@CALL/ERROR_PLANNING');
